import { THIRD_PARTY_SOFTWARE_LIST } from './ThirdPartySoftwareHelper';
import Styles from './AboutDialog.module.scss';

function ThirdPartySoftware(): React.ReactElement {
    return (
        <div className={Styles.thirdPartySoftwareContainer}>
            {THIRD_PARTY_SOFTWARE_LIST.map((item) => (
                <div key={item.name} className={Styles.thirdPartySoftwareRow}>
                    <span className={Styles.thirdPartySoftwareName}>{item.name}</span>
                    <span className={Styles.thirdPartySoftwareSeparator}>|</span>
                    <span className={Styles.thirdPartySoftwareLicense}>{item.license}</span>
                </div>
            ))}
        </div>
    );
}

export default ThirdPartySoftware;
